/**
 * Quick Actions Component
 * Predefined quick queries for common operations
 */

import React, { useState } from 'react';
import './QuickActions.css';

interface QuickAction {
  category: string;
  queries: string[];
}

const quickActions: QuickAction[] = [
  {
    category: 'Kanban Board',
    queries: [
      'Koji board ima najviše tiketa?',
      'Koliko tiketa imam na svakom board-u?',
      'Koji su moji urgentni taskovi?',
      "Pronađi board 'Development'",
      'Daj mi board-ove sa high priority tiketima',
    ],
  },
  {
    category: 'Leads',
    queries: [
      'Pokaži mi nedavne lead-ove',
      'Koliko imam aktivnih lead-ova?',
      "Pronađi lead-ove sa 'Digital' u nazivu",
      'Daj mi kontekst za lead XYZ',
    ],
  },
  {
    category: 'Tickets',
    queries: [
      'Kreiraj tiket za bug u login sistemu',
      'Koliko imam otvorenih tiketa?',
      'Pokaži mi high priority tikete',
      'Dodeli tiket #123 meni',
    ],
  },
  {
    category: 'Analytics',
    queries: [
      'Koliko imamo aktivnih tiketa i lead-ova?',
      "Statistika za board 'Development'",
      'Moj workload ovaj mesec',
    ],
  },
];

interface QuickActionsProps {
  onSelect: (query: string) => void;
  onClose?: () => void;
}

export const QuickActions: React.FC<QuickActionsProps> = ({
  onSelect,
  onClose,
}) => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  return (
    <div className="quick-actions">
      <div className="quick-actions-header">
        <h3>Brzi upiti</h3>
        {onClose && (
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        )}
      </div>

      {!selectedCategory ? (
        // Category selection
        <div className="categories">
          {quickActions.map((action) => (
            <button
              key={action.category}
              className="category-btn"
              onClick={() => setSelectedCategory(action.category)}
            >
              <span className="icon">📋</span>
              {action.category}
            </button>
          ))}
        </div>
      ) : (
        // Query selection
        <div className="queries">
          <button
            className="back-btn"
            onClick={() => setSelectedCategory(null)}
          >
            ← Nazad
          </button>

          <h4>{selectedCategory}</h4>

          <div className="query-list">
            {quickActions
              .find((a) => a.category === selectedCategory)
              ?.queries.map((query) => (
                <button
                  key={query}
                  className="query-btn"
                  onClick={() => {
                    onSelect(query);
                    setSelectedCategory(null);
                  }}
                >
                  <span className="icon">💬</span>
                  {query}
                </button>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};
